import { render } from "./SectionEffdtView.vue?vue&type=template&id=76a49667"
import script from "./SectionEffdtView.vue?vue&type=script&lang=js"
export * from "./SectionEffdtView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__